import { getDefaultExportFromCjs } from './_commonjsHelpers.js';
import { __require as requireReactDatepicker_min } from '../node_modules/react-datepicker/dist/react-datepicker.min.js';

var reactDatepicker_minExports = /*@__PURE__*/ requireReactDatepicker_min();
var DatePicker = /*@__PURE__*/getDefaultExportFromCjs(reactDatepicker_minExports);

export { DatePicker as default };
